import { Component, AfterViewInit, HostListener, OnInit, OnDestroy } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
@Component({
  selector: 'app-cover',
  templateUrl: './cover.component.html',
  styleUrls: ['./cover.component.scss']
})
export class CoverComponent implements AfterViewInit, OnInit, OnDestroy {

  windowsWidth;
  facebookUrl = '';
  buttonShare = false;
  plusIcon;
  plusIcon1 = false;
  plusIcon2 = false;
  plusIcon3 = false;
  footerActive = false;

  imageIcon1 = '../cinemaissue/assets/images/More.svg';
  imageIcon2 = '../cinemaissue/assets/images/More.svg';
  imageIcon3 = '../cinemaissue/assets/images/More.svg';

  constructor() { }
  pointer = 0;
  debounce = true;
  previousScroll = 0;
  rightPointer = 0;
  currentY;
  txt = 'An impressive roster of films. A decade of commitment. Rave reviews. Undeniable talent. But mainstream recognition evaded her. What needs to change?';
  i = 0;
  time = [];

  ngOnInit() {
    this.windowsWidth = window.innerWidth;
    this.goBackToTop();
    this.facebookUrl = window.location.href;
  }

  typeWriter() {
    if (document.getElementById('typingTxt')) {
      this.time[this.i] = setTimeout(() => {
        document.getElementById('typingTxt').innerHTML += this.txt.charAt(this.i);
        if (this.i < this.txt.length) {
          this.i++;
          this.typeWriter();
        }
      }, 40);
    }
  }

  ngAfterViewInit() {
    this.typeWriter();
  }

  touchStart(event) {
    this.currentY = event.touches[0].clientY;
  }


  onScroll(event) {
    const navBar = document.getElementsByClassName('nav-panel active');
    if (navBar.length === 0) {
      if (event.deltaY < 10 && this.debounce) {
        document.getElementById('mainBodyWrap').scrollTo({ 'top': 0, behavior: 'smooth' });
      }
      let force = false;
      if (event.type === 'touchmove') {
        force = true;
      } else {
        force = Math.abs(event.deltaY) > 10;
      }
      if (force && this.debounce && this.pointer < 3) {
        this.debounce = false;
        let direction = false;
        if (event.type === 'touchmove') {
          if (event.touches[0].clientY > this.currentY) {
            direction = true;
          } else {
            direction = false;
          }
        } else {
          if (event.deltaY < 0) {
            direction = true; // reverse flow
          } else {
            direction = false; // forward flow
          }
        }
        if (direction) { // reverse flow
          if (this.rightPointer === 3 && this.pointer === 2 && document.getElementById('textualWrap').scrollTop === 0) {
            this.pointer = 1;
            this.rightPointer = 2;
            document.getElementsByClassName('nav-bar')[0].classList.remove('active');
          } else if (this.pointer === 1 && this.rightPointer === 2) {
            if (document.getElementById('txt0').scrollTop === 0) {
              this.rightPointer = 1;
              this.pointer = 1;
              document.getElementsByClassName('nav-bar')[0].classList.remove('active');
            } else {
              document.getElementById('txt0').scrollTo({ 'top': 0, behavior: 'smooth' });
            }
          } else if (this.pointer === 1 && this.rightPointer === 1) {
            this.pointer = 0;
            this.rightPointer = 1;
            document.getElementsByClassName('nav-bar')[0].classList.remove('active');
          } else if (this.pointer === 0 && this.rightPointer === 1) {
            this.pointer = 0;
            this.rightPointer = 0;
            document.getElementsByClassName('nav-bar')[0].classList.remove('active');
          }
        } else { // forward flow
          if (this.pointer === 0 && this.rightPointer === 0) {
            this.rightPointer = 1;
          } else if (this.pointer === 0 && this.rightPointer === 1) {
            this.pointer = 1;
          } else if (this.pointer === 1 && this.rightPointer === 1) {
            this.rightPointer = 2;
          } else if (this.pointer === 1 && this.rightPointer === 2) {
            if (document.getElementById('txt0').scrollTop === document.getElementById('txt0').scrollHeight
              - document.getElementById('txt0').clientHeight) {
              this.pointer = 2;
              this.rightPointer = 3;
            } else {
              document.getElementById('txt0').scrollTo({
                'top': document.getElementById('txt0').scrollHeight
                  - document.getElementById('txt0').clientHeight, behavior: 'smooth'
              });
            }
          }
        }
        setTimeout(() => {
          this.debounce = true;
        }, 1800);
      }
    }
  }

  updatePosts(event) {
    this.checkIfEnd();
    if (document.getElementById('textualWrap').scrollTop > this.previousScroll) {
      if (this.pointer >= 2 && this.rightPointer === 3) {
        if (document.getElementById('txt' + this.pointer) &&
          document.getElementById('txt' + this.pointer).getBoundingClientRect().top < (window.innerHeight / 2)) {
          this.pointer++;
        }
      }
    } else {
      if (this.pointer >= 3 && this.pointer <= 6) {
        if (document.getElementById('txt' + (this.pointer - 1)) &&
          document.getElementById('txt' + (this.pointer - 1)).getBoundingClientRect().top > (window.innerHeight / 2)) {
          this.pointer--;
        }
      }
    }
    this.previousScroll = document.getElementById('textualWrap').scrollTop;
  }

  gotoTop() {
    this.footerActive = false;
    document.getElementById('mainBodyWrap').scrollTo({ 'top': 0, behavior: 'smooth' });
    document.getElementById('textualWrap').scrollTo({ 'top': 0, behavior: 'smooth' });
    this.pointer = 0;
    this.rightPointer = 0;
    document.getElementById('txt0').scrollTo({ 'top': 0, behavior: 'smooth' });
  }

  goBackToTop() {
    document.getElementsByTagName('body')[0].scroll({
      top: 0,
      behavior: 'smooth'
    });
    document.getElementsByClassName('nav-bar')[0].classList.remove('active');
  }

  checkIfEnd() {
    if (document.getElementById('textualWrap').offsetHeight +
      document.getElementById('textualWrap').scrollTop >=
      document.getElementById('textualWrap').scrollHeight) {
      this.debounce = false;
      document.getElementById('mainBodyWrap').scrollTo({
        'top': document.getElementById('mainBodyWrap').scrollHeight
          - document.getElementById('mainBodyWrap').clientHeight, behavior: 'smooth'
      });
      this.footerActive = true;
      setTimeout(() => {
        this.debounce = true;
      }, 1800);
    } else {
      this.footerActive = false;
      document.getElementsByTagName('body')[0].scrollTo({
        'top': 0
      });
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.windowsWidth = window.innerWidth;
    this.i = 0;
    for (let i = 0; i < this.time.length; i++) {
      clearTimeout(this.time[i]);
    }
    document.getElementById('typingTxt').innerHTML = '';
    this.typeWriter();
  }

  changeThePlusIconOne() {
    this.plusIcon1 = !this.plusIcon1;
    if (this.imageIcon1 === '../cinemaissue/assets/images/More.svg') {
      this.imageIcon1 = '../cinemaissue/assets/images/Less.svg';
    } else {
      this.imageIcon1 = '../cinemaissue/assets/images/More.svg';
    }
  }
  changeThePlusIconTwo() {
    this.plusIcon2 = !this.plusIcon2;
    if (this.imageIcon2 === '../cinemaissue/assets/images/More.svg') {
      this.imageIcon2 = '../cinemaissue/assets/images/Less.svg';
    } else {
      this.imageIcon2 = '../cinemaissue/assets/images/More.svg';
    }
  }
  changeThePlusIconThree() {
    this.plusIcon3 = !this.plusIcon3;
    if (this.imageIcon3 === '../cinemaissue/assets/images/More.svg') {
      this.imageIcon3 = '../cinemaissue/assets/images/Less.svg';
    } else {
      this.imageIcon3 = '../cinemaissue/assets/images/More.svg';
    }
  }

  ngOnDestroy() {
    for (let i = 0; i < this.time.length; i++) {
      clearTimeout(this.time[i]);
    }
  }

  shareButton() {
    this.buttonShare = !this.buttonShare;
    if (this.buttonShare === true) {
      document.getElementById('sharePopup').style.display = 'flex';
    } else {
      document.getElementById('sharePopup').style.display = 'none';
    }
  }

}
